// extracted by mini-css-extract-plugin
export default {"blue":"#cfe5fc"};